<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">DATA ANGGOTA</h6>
        <b-row>
            <div class="form-wrapper-btn submit-btn-wrapper ml-3 mt-0">
                <b-button name="copyIdentitasBtn" variant="pgiBtn" @click="$emit('copy')">SALIN DATA IDENTITAS KE DATA
                    ANGGOTA</b-button>
            </div>
        </b-row>
        <b-row>
            <b-col lg="4" md="6">
                <b-form-group label="No Handphone">
                    <b-form-input v-model="dataAnggota.noHandphoneSekarang" name="dataAnggotaNohp" required :disabled="isEdit">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kota">
                    <div class="d-flex">
                        <multiselect name="dataAnggotaKota" v-model="dataAnggota.kotaSekarang" :options="kota"
                            :internal-search="false" :loading="isLoading" @search-change="search" :allow-empty="false"
                            deselect-label="" select-label="" label="name" track-by="name"
                            placeholder="*Ketik min. 4 huruf untuk mencari..." />
                    </div>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kecamatan">
                    <b-input-group>
                        <b-form-select v-if="dataAnggota.kecLoading == true" v-model="data" name="dataAnggotaKecamatan"
                            disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataAnggota.kecamatanSekarang" name="dataAnggotaKecamatan"
                            :options="dataAnggota.listKecamatan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option
                                    --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataAnggota.loadKecFail == true">
                            <b-button variant="primary" size="sm" @click="loadKecamatan"><i
                                    class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kelurahan">
                    <b-input-group>
                        <b-form-select v-if="dataAnggota.kelLoading == true" v-model="data" name="dataAnggotaKelurahan"
                            disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataAnggota.kelurahanDesaSekarang" name="dataAnggotaKelurahan"
                            :options="dataAnggota.listKelurahan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option
                                    --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataAnggota.loadKelFail == true">
                            <b-button variant="primary" size="sm" @click="loadKelurahan"><i
                                    class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6" class="form-tworow-wrapper">
                <b-row>
                    <b-col cols="6">
                        <b-form-group label="RT">
                            <b-form-input v-model="dataAnggota.rtSekarang" name="dataAnggotaNort" maxlength="3"
                                title="Gunakan format 3 angka (contoh: 001)" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="RW">
                            <b-form-input v-model="dataAnggota.rwSekarang" name="dataAnggotaNorw" maxlength="3"
                                title="Gunakan format 3 angka (contoh: 001)" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Alamat Sekarang">
                    <b-form-textarea v-model="dataAnggota.alamatSekarang" name="dataAnggotaAlamat" maxlength="255"
                        required></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Nomor / Nama Gang">
                    <b-form-input v-model="dataAnggota.nomorGang" name="dataAnggotaNomorGang"
                        maxlength="30"></b-form-input>
                    <span class="text-muted smallText">
                        * Hanya wajib diisi BILA anggota ingin menggadaikan BPKB
                    </span>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Nomor Rumah">
                    <b-form-input v-model="dataAnggota.nomorRumah" name="dataAnggotaNomorRumah"
                        maxlength="30"></b-form-input>
                    <span class="text-muted smallText">
                        * Hanya wajib diisi BILA anggota ingin menggadaikan BPKB
                    </span>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button name="identitasResetBtn" variant="danger" @click="$emit('reset')">Reset Anggota</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name: 'data-anggota',
    props: {
        dataAnggota: { type: Object, required: true },
        isEdit: { type: Boolean, default: false },
    },
    data() {
        return {
            isLoading: false,
            activeSearch: null,
            data: null,
            kota: [],
        }
    },
    watch: {
        "dataAnggota.rtSekarang": function (newValue) {
            const result = newValue.replace(/[^\d]/g, '');
            this.$nextTick(() => this.dataAnggota.rtSekarang = result);
        },
        "dataAnggota.rwSekarang": function (newValue) {
            const result = newValue.replace(/[^\d]/g, '');
            this.$nextTick(() => this.dataAnggota.rwSekarang = result);
        },
    },
    methods: {
        search(searchQuery) {
            if (searchQuery.length >= 4) {
                this.isLoading = true

                if (this.activeSearch == null) this.activeSearch = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearch)
                    this.activeSearch = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                }
            }
            else {
                clearTimeout(this.activeSearch)
                this.activeSearch = null
                this.isLoading = false
            }
        },

        searchKota(searchQuery) {
            this.$axios.get('area/search/kota/?name=' + searchQuery).then(response => {
                this.kota = response.data
                this.isLoading = false
                this.activeSearch = null
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },

        loadKecamatan() {
            this.dataAnggota.kecLoading = true
            this.dataAnggota.loadKecFail = false

            this.$axios.get(`area/kecamatan/${this.dataAnggota.kotaKtp.id}`).then(response => {
                this.dataAnggota.listKecamatan = response.data
                this.dataAnggota.kecLoading = false
            })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },

        loadKelurahan() {
            this.dataAnggota.kelLoading = true
            this.dataAnggota.loadKelFail = false

            this.$axios.get(`area/kelurahan/${this.dataAnggota.kecamatanKtp}`).then(response => {
                this.dataAnggota.listKelurahan = response.data
                this.dataAnggota.kelLoading = false
            })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.loadKelFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },
    },

}
</script>
